import { CheckCircle2, ExternalLink, RotateCcw } from 'lucide-react'
import { APP_BASE_URL } from '@/lib/constants'
import type { Matter } from '@/types'

interface ConfirmationScreenProps {
  matter: Matter
  onLinkAnother: () => void
}

export function ConfirmationScreen({ matter, onLinkAnother }: ConfirmationScreenProps) {
  const viewUrl = `${APP_BASE_URL}/matters/${matter.id}?tab=emails`

  return (
    <div className="flex flex-col items-center justify-center h-full p-6 text-center gap-4">
      <div className="w-14 h-14 rounded-full bg-success-DEFAULT/10 flex items-center justify-center">
        <CheckCircle2 size={32} className="text-success-DEFAULT" />
      </div>

      <div>
        <p className="text-base font-semibold text-secondary-900">Email Linked!</p>
        <p className="text-sm text-secondary-500 mt-1">
          Successfully linked to <span className="font-medium text-secondary-700">{matter.name}</span>
        </p>
      </div>

      <div className="w-full space-y-2 mt-2">
        <a
          href={viewUrl}
          target="_blank"
          rel="noreferrer"
          className="w-full flex items-center justify-center gap-2 py-2.5 px-4 rounded-lg text-sm font-medium text-white bg-brand-gradient hover:opacity-90 transition-opacity"
        >
          View in Athenty
          <ExternalLink size={13} />
        </a>

        <button
          onClick={onLinkAnother}
          className="w-full flex items-center justify-center gap-2 py-2.5 px-4 rounded-lg text-sm font-medium text-secondary-600 border border-secondary-200 hover:bg-secondary-50 transition-colors"
        >
          <RotateCcw size={13} />
          Link another email
        </button>
      </div>
    </div>
  )
}
